<div class="reset-password-container">
    <div class="page-title reset-password-card">
      <h3>Reset Password</h3>
  
      <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="currentPassword">Current Password</label>
          <span class="right-icon-field">
            <input 
              [type]="showCurrentPassword ? 'text' : 'password'" 
              id="currentPassword" 
              pInputText 
              formControlName="currentPassword" 
              placeholder="Enter current password"
              [ngClass]="{
                'invalid-input': resetPasswordForm.controls['currentPassword'].invalid 
                                && resetPasswordForm.controls['currentPassword'].touched
              }"
            >
            <i class="pi" [ngClass]="showCurrentPassword ? 'pi-eye-slash' : 'pi-eye'"  (click)="toggleCurrentPasswordVisibility()"
              style="cursor: pointer"></i>
          </span>
          
          <small *ngIf="resetPasswordForm.controls['currentPassword'].invalid && resetPasswordForm.controls['currentPassword'].touched">
            Password is required (min 6 chars)
          </small>
        </div>

        <div class="form-group">
          <label for="newPassword">New Password</label>
          <span class="right-icon-field">
            <input [type]="showNewPassword ? 'text' : 'password'"  id="newPassword" 
              formControlName="newPassword" pInputText 
              placeholder="Enter new password" [ngClass]="{
                'invalid-input': resetPasswordForm.controls['newPassword'].invalid 
                                && resetPasswordForm.controls['newPassword'].touched
              }">
            <i class="pi" [ngClass]="showNewPassword ? 'pi-eye-slash' : 'pi-eye'"  (click)="toggleNewPasswordVisibility()"
              style="cursor: pointer"
            ></i>
          </span>
          
          <small *ngIf="resetPasswordForm.controls['newPassword'].invalid && resetPasswordForm.controls['newPassword'].touched">
            Password is required (min 6 chars)
          </small>
        </div>


  
        <p-button type="submit" class="primary-btn" [disabled]="loading">
          {{ loading ? 'Processing...' : 'Reset Password' }}
        </p-button>
      </form>
    </div>
  
    <p-toast></p-toast>
  </div>
  